import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import CheckDataProduct from '../js/CheckDataProduct';

function NutritionalValueTable({ nutriments, servingSize }) {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="h4" component="h1" sx={{ pt: 2, textAlign: 'center' }}>
        {t('products.nutritionalValueTable.heading')}
      </Typography>
      <TableContainer>
        <Table aria-label={t('products.nutritionalValueTable.heading')}>
          <TableHead>
            <TableRow>
              <TableCell component="th" scope="row" variant="head">
                {t('products.nutritionalValueTable.firstColumn')}
              </TableCell>
              <TableCell component="th" scope="row" variant="head">
                {t('products.nutritionalValueTable.secondColumn')}
              </TableCell>
              <TableCell component="th" scope="row" variant="head">
                {t('products.nutritionalValueTable.thirdColumn')} ({servingSize})
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row" sx={{ textAlign: 'left' }}>
                {t('products.nutritionalValueTable.energy')}
              </TableCell>
              <TableCell>{CheckDataProduct.checkDataSingleLanguage(`${nutriments['energy-kcal']} kcal`, t('products.nutritionalValueTable.messages.noEnergy'))}</TableCell>
              <TableCell>{CheckDataProduct.checkDataSingleLanguage(`${nutriments['energy-kcal_serving']} kcal`, t('products.nutritionalValueTable.messages.noEnergy'))}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row" sx={{ textAlign: 'left' }}>
                {t('products.nutritionalValueTable.fats')}
              </TableCell>
              <TableCell>{CheckDataProduct.checkDataSingleLanguage(`${nutriments.fat} g`, t('products.nutritionalValueTable.messages.noFats'))}</TableCell>
              <TableCell>{CheckDataProduct.checkDataSingleLanguage(`${nutriments.fat_serving} g`, t('products.nutritionalValueTable.messages.noFats'))}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row" sx={{ textAlign: 'left', pl: '2.5em' }}>
                {t('products.nutritionalValueTable.saturatedFats')}
              </TableCell>
              <TableCell>{CheckDataProduct.checkDataSingleLanguage(`${nutriments['saturated-fat']} g`, t('products.nutritionalValueTable.messages.noSaturatedFats'))}</TableCell>
              <TableCell>{CheckDataProduct.checkDataSingleLanguage(`${nutriments['saturated-fat_serving']} g`, t('products.nutritionalValueTable.messages.noSaturatedFats'))}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row" sx={{ textAlign: 'left' }}>
                {t('products.nutritionalValueTable.carbohydrates')}
              </TableCell>
              <TableCell>{CheckDataProduct.checkDataSingleLanguage(`${nutriments.carbohydrates} g`, t('products.nutritionalValueTable.messages.noCarbohydrates'))}</TableCell>
              <TableCell>{CheckDataProduct.checkDataSingleLanguage(`${nutriments.carbohydrates_serving} g`, t('products.nutritionalValueTable.messages.noCarbohydrates'))}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row" sx={{ textAlign: 'left', pl: '2.5em' }}>
                {t('products.nutritionalValueTable.sugars')}
              </TableCell>
              <TableCell>{CheckDataProduct.checkDataSingleLanguage(`${nutriments.sugars} g`, t('products.nutritionalValueTable.messages.noSugars'))}</TableCell>
              <TableCell>{CheckDataProduct.checkDataSingleLanguage(`${nutriments.sugars_serving} g`, t('products.nutritionalValueTable.messages.noSugars'))}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row" sx={{ textAlign: 'left' }}>
                {t('products.nutritionalValueTable.fibers')}
              </TableCell>
              <TableCell>{CheckDataProduct.checkDataSingleLanguage(`${nutriments.fiber} g`, t('products.nutritionalValueTable.messages.noFibers'))}</TableCell>
              <TableCell>{CheckDataProduct.checkDataSingleLanguage(`${nutriments.fiber_serving} g`, t('products.nutritionalValueTable.messages.noFibers'))}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row" sx={{ textAlign: 'left' }}>
                {t('products.nutritionalValueTable.proteins')}
              </TableCell>
              <TableCell>{CheckDataProduct.checkDataSingleLanguage(`${nutriments.proteins} g`, t('products.nutritionalValueTable.messages.noProteins'))}</TableCell>
              <TableCell>{CheckDataProduct.checkDataSingleLanguage(`${nutriments.proteins_serving} g`, t('products.nutritionalValueTable.messages.noProteins'))}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row" sx={{ textAlign: 'left' }}>
                {t('products.nutritionalValueTable.salt')}
              </TableCell>
              <TableCell>{CheckDataProduct.checkDataSingleLanguage(`${nutriments.salt} g`, t('products.nutritionalValueTable.messages.noSalt'))}</TableCell>
              <TableCell>{CheckDataProduct.checkDataSingleLanguage(`${nutriments.salt_serving} g`, t('products.nutritionalValueTable.messages.noSalt'))}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

NutritionalValueTable.propTypes = {
  nutriments: PropTypes.shape({
    'energy-kcal': PropTypes.number,
    'energy-kcal_serving': PropTypes.number,
    fat: PropTypes.number,
    fat_serving: PropTypes.number,
    'saturated-fat': PropTypes.number,
    'saturated-fat_serving': PropTypes.number,
    carbohydrates: PropTypes.number,
    carbohydrates_serving: PropTypes.number,
    sugars: PropTypes.number,
    sugars_serving: PropTypes.number,
    fiber: PropTypes.number,
    fiber_serving: PropTypes.number,
    proteins: PropTypes.number,
    proteins_serving: PropTypes.number,
    salt: PropTypes.number,
    salt_serving: PropTypes.number,
  }).isRequired,
  servingSize: PropTypes.string.isRequired,
};

export default NutritionalValueTable;
